import { Controller } from "stimulus";

export default class extends Controller
{
    static targets = ["event", "element"];
    connect()
    {
        if(this.elementTarget.classList.contains("special"))
        {
            this.actionPlan = this.eventTarget.querySelector(".action-plan");
            let arrows = this.eventTarget.lastElementChild;
            this.openArrow = arrows.firstElementChild,
            this.closeArrow = arrows.lastElementChild;

            this.eventTarget.addEventListener("click", e =>
            {
                if(this.closeArrow.classList.contains("hidden"))
                {
                    this.openArrow.classList.add("hidden");
                    this.closeArrow.classList.remove("hidden");
                    this.actionPlan.classList.remove("hidden");
                }
                else
                {
                    this.actionPlan.classList.add("hidden");
                    this.closeArrow.classList.add("hidden");
                    this.openArrow.classList.remove("hidden");
                }
            })
        }
    }
}